
/* injects from baggage-loader */

'use strict';

import unlockTemplate from '!!file-loader?name=templates/[name].[ext]!./unlock.html';

/**
* Function that register the all routes for the unlock module.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @param {any} routerHelper
*/
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	* Route definition of the unlock page.
	*/
	const indexNav = 6;
	const indexSubmenu = 5;
	const unlockRoute = {
		state: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].URL,
			templateUrl: unlockTemplate,
			controller: 'UnlockController',
			controllerAs: 'unlockvm',
			resolve: {
				unlock: unlockLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].NAME,
				submenu: true
			},
		}
	}

	routerHelper.configureStates([unlockRoute]);
}

/**
* Function for the lazyLoading configuration in the unlock route.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @returns
*/
function unlockLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const unlockModule = require('./unlock.module');

		$ocLazyLoad.load({
			name: unlockModule.default.name,
		});

		deferred.resolve(unlockModule.default.controller);
	});

	return deferred.promise;
}

export default angular
.module('unlock.routes', [])
.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/components/unlock/unlock.routes.js